export default __webpack_public_path__ + "static/media/Riley-Temple.bb07b439.jpg";